(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    format = format || window.moneyFormat || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m && m[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(m[0], v);
  }

  /* ---------- mobile menu ---------- */
  var menuToggle = $('[data-menu-toggle]');
  var mobileMenu = $('#MobileMenu');
  function setMenu(open) {
    if (!menuToggle || !mobileMenu) return;
    mobileMenu.hidden = !open;
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('menu-open', open);
  }
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () { setMenu(mobileMenu.hidden); });
    mobileMenu.addEventListener('click', function (e) { if (e.target === mobileMenu) setMenu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  }

  /* ---------- search panel ---------- */
  var searchToggle = $('[data-search-toggle]');
  var searchPanel = $('#HeaderSearch');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.hidden;
      searchPanel.hidden = !open;
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = $('input[type=search]', searchPanel); if (i) i.focus(); }
    });
  }

  /* ---------- desktop nav: tap to open on touch devices ---------- */
  $all('.nav__item.has-sub > .nav__link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches) {
        var item = link.parentElement;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          $all('.nav__item.is-open').forEach(function (n) { n.classList.remove('is-open'); });
          item.classList.add('is-open');
        }
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav__item')) $all('.nav__item.is-open').forEach(function (n) { n.classList.remove('is-open'); });
  });

  /* ---------- collection sort ---------- */
  var sort = $('[data-sort-select]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- tabs (complete your setup) ---------- */
  $all('[data-tabs]').forEach(function (root) {
    var tabs = $all('[data-tab]', root);
    var panels = $all('[data-panel]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === id); });
      });
    });
  });

  /* ---------- quantity buttons ---------- */
  $all('[data-qty]').forEach(function (wrap) {
    var input = $('[data-qty-input]', wrap);
    var minus = $('[data-qty-minus]', wrap);
    var plus = $('[data-qty-plus]', wrap);
    if (!input) return;
    minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
    plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  /* ---------- cart: auto-update on quantity change ---------- */
  $all('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (!form) return;
      var hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = 'Update';
      form.appendChild(hidden);
      form.submit();
    });
  });

  /* ---------- product: variant selection + gallery ---------- */
  $all('[data-product-section]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var optionInputs = $all('[data-option-input]', root);
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-to-cart]', root);
    var priceEl = $('[data-price-current]', root);
    var compareEl = $('[data-price-compare]', root);
    var slides = $all('.gallery__slide', root);
    var thumbs = $all('[data-thumb]', root);

    function showMedia(id) {
      if (!id) return;
      var found = false;
      slides.forEach(function (s) {
        var on = String(s.getAttribute('data-media-id')) === String(id);
        if (on) found = true;
        s.classList.toggle('is-active', on);
      });
      if (found) thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.getAttribute('data-thumb')) === String(id)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

    function selectedValues() {
      var vals = [];
      $all('[data-option-index]', root).forEach(function (fs) {
        var checked = $('[data-option-input]:checked', fs);
        vals.push(checked ? checked.value : null);
        var label = $('[data-option-selected]', fs);
        if (label && checked) label.textContent = checked.value;
      });
      return vals;
    }

    function findVariant(vals) {
      return product.variants.filter(function (v) {
        return vals.every(function (val, i) { return v.options[i] === val; });
      })[0];
    }

    function update() {
      var variant = findVariant(selectedValues());
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) { idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.hidden = false; compareEl.textContent = formatMoney(variant.compare_at_price);
        } else { compareEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    optionInputs.forEach(function (i) { i.addEventListener('change', update); });
    // sync initial thumb state
    var activeSlide = $('.gallery__slide.is-active', root);
    if (activeSlide) showMedia(activeSlide.getAttribute('data-media-id'));
  });
})();